export default "__VITE_ASSET__C6$Hr5ce__"